import { useState } from "react";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { ScrollButtonFlatlist } from "../ChatUI/ScrollButtonFlatlist";
import { RecommendedCard } from "./RecommendedCard";
import { RecommendedCardSkeleton } from "./RecommendedCardSkeleton";
import { computeTaskCardWidth } from "./helpers";
import type { TasksSectionItem } from "./types";

interface Props {
	items: TasksSectionItem[];
	isLoading?: boolean;
}

const SKELETON_COUNT = 2;
const GAP = 8;

export const TasksSection = ({ items, isLoading = false }: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	const [containerWidth, setContainerWidth] = useState(0);

	const paddingHorizontal = isMobile ? 16 : 2;
	const availableWidth = containerWidth - paddingHorizontal * 2;
	const cardWidth =
		containerWidth > 0
			? computeTaskCardWidth(
					availableWidth,
					GAP,
					isLoading ? SKELETON_COUNT : items.length,
				)
			: undefined;

	return (
		<Box onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}>
			{containerWidth > 0 && cardWidth ? (
				isLoading ? (
					<ScrollButtonFlatlist
						data={[...new Array(SKELETON_COUNT).keys()]}
						renderItem={() => <RecommendedCardSkeleton cardWidth={cardWidth} />}
						keyExtractor={(item) => `recommended-card-skeleton-${item}`}
						horizontal
						showsHorizontalScrollIndicator={false}
						wrapOnLargeScreens={false}
						scrollStep={cardWidth + GAP}
						snapToInterval={cardWidth + GAP}
						snapToAlignment="start"
						edgeFadeColor={theme.colors.background}
						contentContainerStyle={{
							paddingHorizontal,
							alignItems: "stretch",
							gap: GAP,
							paddingBottom: 8,
						}}
					/>
				) : (
					<ScrollButtonFlatlist
						data={items}
						renderItem={({ item }) => (
							<RecommendedCard {...item} cardWidth={cardWidth} />
						)}
						keyExtractor={(item) => `${item.title}-${item.body}`}
						horizontal
						showsHorizontalScrollIndicator={false}
						wrapOnLargeScreens={false}
						scrollStep={cardWidth + GAP}
						snapToInterval={cardWidth + GAP}
						snapToAlignment="start"
						edgeFadeColor={theme.colors.background}
						contentContainerStyle={{
							paddingHorizontal,
							alignItems: "stretch",
							gap: GAP,
							paddingBottom: 8,
						}}
					/>
				)
			) : null}
		</Box>
	);
};
